<template>
  <div class="franquicia-hero" :style="heroStyle">
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <v-container>
        <div class="hero-title-holder">
          <h1 class="hero-title">{{ titulo || 'SUCURSALES' }}</h1>
          <p v-if="subtitulo" class="hero-subtitle">{{ subtitulo }}</p>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FranquiciaHero',
  props: {
    imagenFondo: {
      type: String,
      default: null
    },
    titulo: {
      type: String,
      default: 'SUCURSALES'
    },
    subtitulo: {
      type: String,
      default: null
    },
    colorPrimario: {
      type: String,
      default: '#1976D2'
    },
    colorSecundario: {
      type: String,
      default: '#424242'
    }
  },
  computed: {
    heroStyle () {
      const styles = {
        backgroundColor: this.colorPrimario,
        minHeight: '400px'
      }
      if (this.imagenFondo) {
        styles.backgroundImage = `url(${this.imagenFondo})`
        styles.backgroundSize = 'cover'
        styles.backgroundPosition = 'center'
        styles.backgroundRepeat = 'no-repeat'
      }
      return styles
    }
  }
}
</script>

<style scoped>
.franquicia-hero {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 400px;
  background-color: #1976D2;
  overflow: hidden;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.6) 100%);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  width: 100%;
  padding: 80px 0;
}

.hero-title-holder {
  text-align: center;
  color: white;
  animation: fadeInUp 0.8s ease-out;
}

.hero-title {
  font-size: 3rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  letter-spacing: 2px;
}

.hero-subtitle {
  font-size: 1.25rem;
  margin-top: 16px;
  opacity: 0.95;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 960px) {
  .franquicia-hero {
    min-height: 300px;
  }

  .hero-content {
    padding: 60px 0;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }
}
</style>
